export default "__VITE_ASSET__Ci9JSaUo__"